import { render } from "./EventModule.vue?vue&type=template&id=caef2e1c&scoped=true"
import script from "./EventModule.vue?vue&type=script&lang=js"
export * from "./EventModule.vue?vue&type=script&lang=js"

import "./EventModule.vue?vue&type=style&index=0&id=caef2e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caef2e1c"]])

export default __exports__